import { MuiGrid } from '@/features/shared/material-ui';
import { makeStyles } from '@material-ui/core/styles';
import { range } from 'lodash/fp';
import React from 'react';
import CardSkeleton from '../Card/CardSkeleton';

const useResultBlockPlaceholderStyles = makeStyles({
  card: { height: '100%' },
});

export const ResultBlockPlaceholder = ({ animated = true }: any) => {
  const classes = useResultBlockPlaceholderStyles();

  return (
    <MuiGrid container spacing={3}>
      {range(0, 3).map((id) => (
        // eslint-disable-next-line react/no-array-index-key
        <MuiGrid key={id} item xs={12} sm={6} md={6} lg={4}>
          <div className={classes.card}>
            <CardSkeleton animated={animated} />
          </div>
        </MuiGrid>
      ))}
    </MuiGrid>
  );
};
